module.exports = __webpack_public_path__ + "static/media/gallery-8.4f1803ed.jpg";